var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9955 33.263V22.8464H23.3289V33.263C23.3289 34.4089 24.2664 35.3464 25.4122 35.3464H31.6622C32.808 35.3464 33.7455 34.4089 33.7455 33.263V18.6797H37.2872C38.2455 18.6797 38.7039 17.4922 37.9747 16.8672L20.558 1.17969C19.7664 0.471354 18.558 0.471354 17.7664 1.17969L0.349692 16.8672C-0.358642 17.4922 0.0788581 18.6797 1.03719 18.6797H4.57886V33.263C4.57886 34.4089 5.51636 35.3464 6.66219 35.3464H12.9122C14.058 35.3464 14.9955 34.4089 14.9955 33.263Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.cc570e9096cb427479988d7a62bb18d6.svg";
export { ForwardRef as ReactComponent };